(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhc-new-arrivals"] && !Shopify.designMode) return;
  try {
    
/*
 * BHC — product rail.
 *
 * Position is owned by JS, not by the CSS keyframes. That is the whole point:
 * the previous version froze the track, let you scrub it, then restarted the
 * CSS animation from a computed negative delay — and any error in that
 * computation showed up as the rail snapping back to where the scrub started.
 * Here there is one `offset` variable, it only ever moves by what you or the
 * autoplay tell it to, and nothing ever recomputes it from scratch.
 *
 * Scroll intent is resolved before anything is cancelled: a mostly-vertical
 * wheel is left alone so the page scrolls normally even when the pointer is
 * over the rail, and only a mostly-horizontal wheel moves the rail.
 *
 * Pointer capture is taken LAZILY — only once a press has actually travelled
 * past DRAG_SLOP. Capturing on pointerdown retargets the compatibility mouse
 * events too, so the click that follows a plain tap was dispatched at the
 * viewport instead of at the card's <a>, and the link never navigated. That
 * was the "clicking a hat in the slider does nothing" bug.
 */
(function () {
  var SPEED = 26;        // px per second of autoplay drift
  var IDLE_MS = 700;     // pause after the last manual input before drifting again
  var DRAG_SLOP = 6;     // px of movement before a pointer press counts as a drag

  function init(viewport) {
    var track = viewport.querySelector('.bhc-new-arrivals__track');
    if (!track || track.dataset.bhcRail) return;
    track.dataset.bhcRail = '1';
    track.classList.add('is-js');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var offset = 0;        // current translateX, always <= 0
    var half = 0;          // width of one copy of the set
    var idleUntil = 0;
    var hovering = false;
    var last = 0;
    var onScreen = true;   // rAF is parked while the rail is out of view
    var dragging = false;
    var dragMoved = 0;
    var dragStartX = 0;
    var pointerId = null;
    var captured = false;

    function measure() {
      half = track.scrollWidth / 2;
      if (half > 0) offset = wrap(offset);
    }

    // Keep offset inside [-half, 0) so the duplicated second copy always
    // covers the gap. Works for arbitrarily large deltas, so a fast flick
    // can't push the rail off the end.
    function wrap(v) {
      if (!half) return v;
      v = v % half;
      if (v > 0) v -= half;
      return v;
    }

    var painted = null;
    function paint() {
      // Writing the same transform still costs a style recalculation; at rest
      // the loop would otherwise re-set an identical value 60 times a second.
      var v = offset.toFixed(2);
      if (v === painted) return;
      painted = v;
      track.style.transform = 'translate3d(' + v + 'px,0,0)';
    }

    function move(dx) {
      offset = wrap(offset + dx);
      paint();
    }

    function frame(now) {
      if (!last) last = now;
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;

      var idle = now > idleUntil;
      if (!reduce && !hovering && !dragging && idle && half) {
        move(-SPEED * dt);
      }
      if (onScreen) window.requestAnimationFrame(frame);
    }

    /* ---- wheel: vertical belongs to the page, horizontal to the rail ---- */
    viewport.addEventListener('wheel', function (e) {
      // Resolve intent first. A trackpad two-finger scroll down reports a
      // large deltaY and a small incidental deltaX; treating that as
      // horizontal is what used to hijack the page.
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   // let the page have it
      if (e.deltaX === 0) return;

      e.preventDefault();
      move(-e.deltaX);
      idleUntil = performance.now() + IDLE_MS;
    }, { passive: false });

    /* ---- pointer drag ---- */
    viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      dragging = true;
      dragMoved = 0;
      dragStartX = e.clientX;
      pointerId = e.pointerId;
      captured = false;
      last = 0;
      track.classList.add('is-dragging');
      // No setPointerCapture here — see the note at the top of this file.
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - dragStartX;
      dragStartX = e.clientX;
      dragMoved += Math.abs(dx);
      if (dragMoved > DRAG_SLOP) {
        // Now it is a drag rather than a tap, so take the pointer: this keeps
        // the scrub alive if the cursor leaves the rail mid-drag, and by this
        // point the click is going to be suppressed anyway.
        if (!captured) {
          try { viewport.setPointerCapture(pointerId); captured = true; } catch (err) {}
        }
        move(dx);
      }
    });

    function endDrag(e) {
      if (!dragging || (e && e.pointerId !== pointerId)) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (captured && pointerId !== null && viewport.hasPointerCapture(pointerId)) {
        viewport.releasePointerCapture(pointerId);
      }
      captured = false;
      pointerId = null;
      idleUntil = performance.now() + IDLE_MS;
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    // A drag that ended on a card must not also follow that card's link.
    viewport.addEventListener('click', function (e) {
      if (dragMoved > DRAG_SLOP) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = 0;
      }
    }, true);

    /* ---- autoplay pauses under the cursor, as before ---- */
    viewport.addEventListener('pointerenter', function () { hovering = true; });
    viewport.addEventListener('pointerleave', function () { hovering = false; });

    /* No reason to animate a rail nobody can see. Parking the loop when the
       section scrolls out of view is the difference between one continuous
       60fps animation for the whole session and one that only runs where it
       is visible. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var vis = entries[0].isIntersecting;
        if (vis === onScreen) return;
        onScreen = vis;
        if (onScreen) {
          last = 0;
          window.requestAnimationFrame(frame);
        }
      }, { rootMargin: '200px 0px' }).observe(viewport);
    }

    /* A backgrounded tab stops firing rAF. Drop the timestamp on the way back
       in so the first frame after returning measures a fresh delta instead of
       the whole time away (dt is clamped as well, so this is belt and braces). */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      last = 0;
      if (onScreen) window.requestAnimationFrame(frame);
    });

    /* ---- keep the wrap point correct as images and fonts settle ---- */
    measure();
    paint();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    setTimeout(measure, 1200);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(track);

    window.requestAnimationFrame(frame);
  }

  document.querySelectorAll('.bhc-new-arrivals__viewport').forEach(init);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.bhc-new-arrivals__viewport').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhc-product-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    var modal = document.getElementById('bhc-size-modal');
    if (!modal) return;

    document.querySelectorAll('[data-bhc-size-open]').forEach(function (btn) {
      if (btn.dataset.bhcBound) return;
      btn.dataset.bhcBound = '1';
      btn.addEventListener('click', function () {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          // Safari before 15.4 has no <dialog>. Without this the sizing
          // guide is simply dead for those visitors.
          modal.setAttribute('open', '');
        }
      });
    });

    modal.querySelectorAll('[data-bhc-size-close]').forEach(function (btn) {
      if (btn.dataset.bhcBound) return;
      btn.dataset.bhcBound = '1';
      btn.addEventListener('click', function () {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      });
    });

    // Click the backdrop to dismiss. The dialog element itself fills the
    // viewport, so a click landing on it rather than on the panel is a
    // backdrop click.
    if (!modal.dataset.bhcBound) {
      modal.dataset.bhcBound = '1';
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.close();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
